import { render, staticRenderFns } from "./BrandCard.vue?vue&type=template&id=61907f1c&"
import script from "./BrandCard.vue?vue&type=script&lang=js&"
export * from "./BrandCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports